import {StyleSheet} from 'react-native';

const styles = StyleSheet.create({
  tileImageContainer: {
    width: '100%',

    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
  },
  tileImage: {
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
  },
  tileVideo: {
    width: '100%',
    aspectRatio: 1922 / 1080,
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
  },
  imageContainer: {
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 5,
    },
    shadowOpacity: 0.29,
    shadowRadius: 4.65,
    elevation: 7,
  },
  topMargin: {
    marginTop: 16,
  },
  imageResponsive: {
    width: '100%',
    height: undefined,
    aspectRatio: 1,
  },
  videoContainer: {
    borderRadius: 4,
    width: '100%',
    paddingLeft: 1, // Annoying slight black line
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 5,
    },
    shadowOpacity: 0.29,
    shadowRadius: 4.65,
    elevation: 7,
  },
  video: {
    borderRadius: 4,
    width: '100%',
    aspectRatio: 1920 / 1080,
  },
  youtube: {
    width: '100%',
    aspectRatio: 1920 / 1080,
    marginTop: 16,
    borderRadius: 4,
    borderWidth: 0,
  },
});

export default styles;
